/* KP: "View all" follows the selected tab's collection.
   Loaded by kp-featured-products.liquid when the section's
   "'View all' follows selected tab" checkbox is on. Tab buttons carry
   data-kp-tab-url; on click the section's View all link is repointed. */
(function () {
  if (window.kpViewallTabsBound) return;
  window.kpViewallTabsBound = true;

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[class*="products-feed__tablinks--"]');
    if (!tab || !tab.dataset.kpTabUrl) return;

    var section = tab.closest('[data-section-id]');
    if (!section) return;

    var wrap = section.querySelector('[data-kp-viewall]');
    if (!wrap) return;

    var link = wrap.querySelector('a.button');
    if (link) link.setAttribute('href', tab.dataset.kpTabUrl);
  });
})();
